import { useState } from 'react';
import FooterTextContainer from '../../components/containers/auth/footer-text.container';
import LoginForm from '../../components/form/forms/login.form';
import AuthLayout from '../../components/layouts/auth.layout';

export default function Login() {
  const [alt, setAlt] = useState(false);

  const toggle = () => setAlt((prev) => !prev);

  return (
    <AuthLayout title="log in">
      <AuthLayout.Form>
        <LoginForm alt={alt} />
      </AuthLayout.Form>
      <AuthLayout.Footer>
        <FooterTextContainer
          text={alt ? 'Already have an account?' : "Don't have an account?"}
          actionText={alt ? 'Log In' : 'Sign Up'}
          action={toggle}
        />
      </AuthLayout.Footer>
    </AuthLayout>
  );
}
